<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vii"><strong>CONTENTS</strong></a></h1><a id="page_vii">
</a><p class="toc-fm"><a id="page_vii"></a><a href="#/006_Foreword#fm-1"><em>Foreword</em></a></p>
<p class="toc-fm"><a href="#/007_Preface#fm-2"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/008_Abbre#fm-3"><em>Abbreviations</em></a></p>
<p class="toc-chap"><a href="#/009_Chapter01#ch-1"><strong>THE EPISTLE TO THE COLOSSIANS</strong></a></p>
<p class="toc-sec"><a href="#/009_Chapter01aBib#sec-1">BIBLIOGRAPHY</a></p>
<p class="toc-sec"><a href="#/009_Chapter01bInt#sec-2">INTRODUCTION</a></p>
<p class="toc-sec2"><a href="#/009_Chapter01bInt#sec2-1">THE SIGNIFICANCE OF THE LETTER</a></p>
<p class="toc-sec2"><a href="#/009_Chapter01bInt#sec2-2">COLOSSAE AND THE ESTABLISHMENT OF CHRISTIANITY THERE</a></p>
<p class="toc-sec2"><a href="#/009_Chapter01bInt#sec2-3">THE TROUBLE AT COLOSSAE</a></p>
<p class="toc-sec3"><a href="#/009_Chapter01bInt#sec3-1"><em>Presuppositions</em></a></p>
<p class="toc-sec3"><a href="#/009_Chapter01bInt#sec3-2"><em>Gnosticizing Syncretism … ?</em></a></p>
<p class="toc-sec3"><a href="#/009_Chapter01bInt#sec3-3"><em>… or Jewish?</em></a></p>
<p class="toc-sec3"><a href="#/009_Chapter01bInt#sec3-4"><em>The Colossian Philosophy</em></a></p>
<p class="toc-sec2"><a href="#/009_Chapter01bInt#sec2-4">WHO WROTE COLOSSIANS?</a></p>
<p class="toc-sec2"><a href="#/009_Chapter01bInt#sec2-5">WHERE AND WHEN WAS COLOSSIANS WRITTEN?</a></p>
<p class="toc-sec2"><a href="#/009_Chapter01bInt#sec2-6">THE STRUCTURE OF COLOSSIANS</a></p>
<p class="toc-seca"><a href="#/009_Chapter01cComm#page_43">COMMENTARY</a></p>
<p class="toc-sec2"><a href="#/009_Chapter01cComm#sec2-7">ADDRESS AND GREETING (1:1-2)</a></p>
<p class="toc-sec2"><a href="#/009_Chapter01cComm#sec2-8">EXTENDED THANKSGIVING (1:3-23)</a></p>
<p class="toc-sec3"><a href="#/009_Chapter01cComm#sec3-5"><em>Thanksgiving (1:3-8)</em></a></p>
<p class="toc-sec3"><a href="#/009_Chapter01cComm#sec3-6"><em>Prayer for the Colossian Recipients (1:9-14)</em></a></p>
<p class="toc-sec3"><a href="#/009_Chapter01cComm#sec3-7"><em>A Hymn in Praise of Christ (1:15-20)</em></a></p>
<p class="toc-sec3"><a href="#/009_Chapter01cComm#sec3-8"><em>Reconciliation and Response (1:21-23)</em></a></p>
<p class="toc-sec2"><a href="#/009_Chapter01cComm#sec2-9">A PERSONAL STATEMENT (1:24–2:5)</a></p>
<p class="toc-sec3"><a href="#/009_Chapter01cComm#sec3-9"><em>Paul’s Commitment to the Gospel (1:24-29)</em></a></p>
<p class="toc-sec3"><a id="page_viii"></a><a href="#/009_Chapter01cComm#sec3-10"><em>Paul’s Commitment to the Colossians (2:1-5)</em></a></p>
<p class="toc-sec2"><a href="#/009b_Chapter01cComm#sec2-10">THE THEME OF THE LETTER (2:6–4:6)</a></p>
<p class="toc-sec2"><a href="#/009b_Chapter01cComm#sec2-11">THE THEMATIC STATEMENT (2:6-7)</a></p>
<p class="toc-sec2"><a href="#/009b_Chapter01cComm#sec2-12">THE CROSS OF CHRIST RENDERS UNNECESSARY ANY FURTHER HUMAN TRADITIONS AND RULES (2:8-23)</a></p>
<p class="toc-sec3"><a href="#/009b_Chapter01cComm#sec3-11"><em>The Scope of Christ’s Accomplishments on the Cross (2:8-15)</em></a></p>
<p class="toc-sec3"><a href="#/009b_Chapter01cComm#sec3-12"><em>Beware of Claims That There Are More Important Practices and Experiences (2:16-19)</em></a></p>
<p class="toc-sec3"><a href="#/009b_Chapter01cComm#sec3-13"><em>Life in Christ Does Not Depend on Observance of Jewish Practices (2:20-23)</em></a></p>
<p class="toc-sec2"><a href="#/009b_Chapter01cComm#sec2-13">THE PATTERN OF LIVING THAT FOLLOWS FROM THE CROSS (3:1–4:6)</a></p>
<p class="toc-sec3"><a href="#/009b_Chapter01cComm#sec3-14"><em>The Perspective from Which the Christian Life Should Be Lived (3:1-4)</em></a></p>
<p class="toc-sec3"><a href="#/009c_Chapter01cComm#sec3-15"><em>General Guidelines and Practical Exhortations (3:5-17)</em></a></p>
<p class="toc-sec3"><a href="#/009c_Chapter01cComm#sec3-16"><em>Household Rules (3:18–4:1)</em></a></p>
<p class="toc-sec3"><a href="#/009c_Chapter01cComm#sec3-17"><em>Concluding Exhortations (4:2-6)</em></a></p>
<p class="toc-sec2"><a href="#/009c_Chapter01cComm#sec2-14">CONCLUSION (4:7-18)</a></p>
<p class="toc-sec3"><a href="#/009c_Chapter01cComm#sec3-18"><em>Maintaining Communication (4:7-9)</em></a></p>
<p class="toc-sec3"><a href="#/009c_Chapter01cComm#sec3-19"><em>Greetings (4:10-17)</em></a></p>
<p class="toc-sec3"><a href="#/009c_Chapter01cComm#sec3-20"><em>A Final, Personal Greeting (4:18)</em></a></p>
<p class="toc-chap"><span href="#/010_Chapter02#ch-2" title="Link target outside of Sample"><strong>THE EPISTLE TO PHILEMON</strong></span></p>
<p class="toc-sec"><a href="#/010_Chapter02aBib#sec-3">BIBLIOGRAPHY</a></p>
<p class="toc-sec"><a href="#/010_Chapter02bInt#sec-4">INTRODUCTION</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02bInt#sec2-15">THE AUTHOR</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02bInt#sec2-16">THE RECIPIENT</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02bInt#sec2-17">THE OCCASION</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02bInt#sec2-18">THE PLACE OF WRITING</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02bInt#sec2-19">THE STRUCTURE OF THE LETTER</a></p>
<p class="toc-seca"><a href="#/010_Chapter02cComm#page_310">COMMENTARY</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02cComm#sec2-20">ADDRESS AND GREETING (1-3)</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02cComm#sec2-21">THANKSGIVING AND PRAYER (4-7)</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02cComm#sec2-22">APPEAL TO PHILEMON (8-20)</a></p>
<p class="toc-sec2"><a href="#/010_Chapter02cComm#sec2-23">IN CONCLUSION (21-25)</a><a id="page_ix"></a></p><a id="page_ix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?8cd1226a